import React, { useState ,useEffect} from 'react'
import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

const ResultStudentTerm1 = () => {
     const [selectedTerm,setSelectedTerm]=useState("Term I");

    const [studied,setStudied]=useState("");
    const [studiedRoman,setStudiedRoman]=useState("");
    const [classSection,setClassSection] = useState("");
    const [classRollNumber,setClassRollNumber] = useState("");
    const [studentIdNumber,setStudentIdNumber] = useState("");
    const [studentName,setStudentName] = useState("");
    const [dateOfBirth,setDateOfBirth] = useState("");
    const [mothersName,setMothersName] = useState("");
    const [fathersName,setFathersName] = useState("");
    const [academicSession,setAcademicSession] = useState("");
  
  
    const [perTestExamEnglishTerm1,setPerTestExamEnglishTerm1] = useState("");
    const [noteBookEnglishTerm1,setNoteBookEnglishTerm1] = useState("");
    const [subjectEnrichmentEnglishTerm1,setSubjectEnrichmentEnglishTerm1] = useState("");
    const [halfYearlyExamEnglishTerm1,setHalfYearlyExamEnglishTerm1] = useState("");
  
    const [perTestExamHindiTerm1,setPerTestExamHindiTerm1] = useState("");
    const [noteBookHindiTerm1,setNoteBookHindiTerm1] = useState("");
    const [subjectEnrichmentHindiTerm1,setSubjectEnrichmentHindiTerm1] = useState("");
    const [halfYearlyExamHindiTerm1,setHalfYearlyExamHindiTerm1] = useState("");
  
    
    const [perTestExamScienceTerm1,setPerTestExamScienceTerm1] = useState("");
    const [noteBookScienceTerm1,setNoteBookScienceTerm1] = useState("");
    const [subjectEnrichmentScienceTerm1,setSubjectEnrichmentScienceTerm1] = useState("");
    const [halfYearlyExamScienceTerm1,setHalfYearlyExamScienceTerm1] = useState("");
  
    const [perTestExamMathsTerm1,setPerTestExamMathsTerm1] = useState("");
    const [noteBookMathsTerm1,setNoteBookMathsTerm1] = useState("");
    const [subjectEnrichmentMathsTerm1,setSubjectEnrichmentMathsTerm1] = useState("");
    const [halfYearlyExamMathsTerm1,setHalfYearlyExamMathsTerm1] = useState("");
  
    
    const [perTestExamSanskritTerm1,setPerTestExamSanskritTerm1] = useState("");
    const [noteBookSanskritTerm1,setNoteBookSanskritTerm1] = useState("");
    const [subjectEnrichmentSanskritTerm1,setSubjectEnrichmentSanskritTerm1] = useState("");
    const [halfYearlyExamSanskritTerm1,setHalfYearlyExamSanskritTerm1] = useState("");
  
    const [perTestExamSocialScienceTerm1,setPerTestExamSocialScienceTerm1] = useState("");
    const [noteBookSocialScienceTerm1,setNoteBookSocialScienceTerm1] = useState("");
    const [subjectEnrichmentSocialScienceTerm1,setSubjectEnrichmentSocialScienceTerm1] = useState("");
    const [halfYearlyExamSocialScienceTerm1,setHalfYearlyExamSocialScienceTerm1] = useState("");
  
  
  
  
    const [perTestExamEnglishTerm2,setPerTestExamEnglishTerm2] = useState("");
    const [noteBookEnglishTerm2,setNoteBookEnglishTerm2] = useState("");
    const [subjectEnrichmentEnglishTerm2,setSubjectEnrichmentEnglishTerm2] = useState("");
    const [halfYearlyExamEnglishTerm2,setHalfYearlyExamEnglishTerm2] = useState("");
  
    const [perTestExamHindiTerm2,setPerTestExamHindiTerm2] = useState("");
    const [noteBookHindiTerm2,setNoteBookHindiTerm2] = useState("");
    const [subjectEnrichmentHindiTerm2,setSubjectEnrichmentHindiTerm2] = useState("");
    const [halfYearlyExamHindiTerm2,setHalfYearlyExamHindiTerm2] = useState("");
  
    
    const [perTestExamScienceTerm2,setPerTestExamScienceTerm2] = useState("");
    const [noteBookScienceTerm2,setNoteBookScienceTerm2] = useState("");
    const [subjectEnrichmentScienceTerm2,setSubjectEnrichmentScienceTerm2] = useState("");
    const [halfYearlyExamScienceTerm2,setHalfYearlyExamScienceTerm2] = useState("");
  
    const [perTestExamMathsTerm2,setPerTestExamMathsTerm2] = useState("");
    const [noteBookMathsTerm2,setNoteBookMathsTerm2] = useState("");
    const [subjectEnrichmentMathsTerm2,setSubjectEnrichmentMathsTerm2] = useState("");
    const [halfYearlyExamMathsTerm2,setHalfYearlyExamMathsTerm2] = useState("");
  
    
    const [perTestExamSanskritTerm2,setPerTestExamSanskritTerm2] = useState("");
    const [noteBookSanskritTerm2,setNoteBookSanskritTerm2] = useState("");
    const [subjectEnrichmentSanskritTerm2,setSubjectEnrichmentSanskritTerm2] = useState("");
    const [halfYearlyExamSanskritTerm2,setHalfYearlyExamSanskritTerm2] = useState("");
  
    const [perTestExamSocialScienceTerm2,setPerTestExamSocialScienceTerm2] = useState("");
    const [noteBookSocialScienceTerm2,setNoteBookSocialScienceTerm2] = useState("");
    const [subjectEnrichmentSocialScienceTerm2,setSubjectEnrichmentSocialScienceTerm2] = useState("");
    const [halfYearlyExamSocialScienceTerm2,setHalfYearlyExamSocialScienceTerm2] = useState("");
  
  
    const Class =[
      {num:1,val:"I"},
      {num:2,val:"II"},
      {num:3,val:"III"},
      {num:4,val:"IV"},
      {num:5,val:"V"},
      {num:6,val:"VI"},
      {num:7,val:"VII"},
      {num:8,val:"VIII"},
      {num:9,val:"IX"},
      {num:10,val:"X"},
      {num:11,val:"XI"},
      {num:12,val:"XII"}, 
    ]
  
  
  
   useEffect(()=>{
    if(studied.length>0 && studied!=="null"){ const temp=Class.find((elem)=>elem.num===parseInt(studied)).val
     setStudiedRoman(temp);}
     else if(studied==="null"){ setStudiedRoman("Please Select Standard")}
    },[studied])
  
    const addresults = async () => {
      await addDoc(collection(db, "resultStudent"), {
       
        studied,
        studiedRoman,
        classSection,
        classRollNumber,
        studentIdNumber,
        studentName,  
        mothersName,
        fathersName,
        dateOfBirth,
        academicSession,
        perTestExamEnglishTerm1,
        noteBookEnglishTerm1,
        subjectEnrichmentEnglishTerm1,
        halfYearlyExamEnglishTerm1,
        totalObtainEnglishTerm1,
        perTestExamHindiTerm1,
        noteBookHindiTerm1,
        subjectEnrichmentHindiTerm1,
        halfYearlyExamHindiTerm1,
        totalObtainHindiTerm1,
        perTestExamMathsTerm1,
        noteBookMathsTerm1,
        subjectEnrichmentMathsTerm1,
        halfYearlyExamMathsTerm1,
        totalObtainMathsTerm1,
        perTestExamSanskritTerm1,
        subjectEnrichmentSanskritTerm1,
        noteBookSanskritTerm1,
        halfYearlyExamSanskritTerm1,
        totalObtainSanskritTerm1,
        perTestExamScienceTerm1,
        noteBookScienceTerm1,
        subjectEnrichmentScienceTerm1,
        halfYearlyExamScienceTerm1,
        totalObtainScienceTerm1,
        perTestExamSocialScienceTerm1,
        noteBookSocialScienceTerm1,
        subjectEnrichmentSocialScienceTerm1,
        halfYearlyExamSocialScienceTerm1,
        totalObtainSocialScienceTerm1,
        totalMarksTerm1,
        totalObtainedMarksTerm1,
        percentageTerm1
      }).then(()=>{
        window.location.reload(false)
      })
    }
  
  
    let totalMarksTerm1 = 600 ;
  
    let totalMarksTerm2 = 600 ;
  
    let ovarallMarks = 1200 ;
  
    const showGradeTerm1 = (marks)=> {
    
      if (marks < 33) {
        return "Fail"
      } else if (marks >= 33 && marks < 40) { 
        return "D"
      } else if (marks >= 40 && marks < 50) {
        return "C2"
      }else if (marks >= 50 && marks < 60) {
        return "C1"
      }else if (marks >= 60 && marks < 70) {
        return "B2"
      }else if (marks >= 70 && marks < 80) {
        return "B1"
      }else if (marks >= 80 && marks < 90) {
        return "A2"
      }else if (marks >= 90 && marks < 100) {
        return "A1"
      } else {
        return "N/A"
      }
    }
  
   
    const showTotalGradeTerm1 = (marks)=> {
      if (marks < 198) {
        return "Fail"
      } else if (marks >= 198 && marks < 240) {
        return "D"
      } else if (marks >= 240 && marks < 300) {
        return "C2"
      }else if (marks >= 300 && marks < 360) {
        return "C1"
      }else if (marks >= 360 && marks < 420) {
        return "B2"
      }else if (marks >= 420 && marks < 480) {
        return "B1"
      }else if (marks >= 480 && marks < 540) {
        return "A2"
      }else if (marks >= 540 && marks < 600) {
        return "A1"
      } else {
        return "N/A"
      }
    }
    
  
  
    const showGradeTerm2 = (marks)=> {
      if (marks < 33) {
        return "Fail"
      } else if (marks >= 33 && marks < 40) {
        return "D"
      } else if (marks >= 40 && marks < 50) {
        return "C2"
      }else if (marks >= 50 && marks < 60) {
        return "C1"
      }else if (marks >= 60 && marks < 70) {
        return "B2"
      }else if (marks >= 70 && marks < 80) {
        return "B1"
      }else if (marks >= 80 && marks < 90) {
        return "A2"
      }else if (marks >= 90 && marks < 100) {
        return "A1"
      } else {
        return "Undefined"
      }
    }
  
   
    const showTotalGradeTerm2 = (marks)=> {
      if (marks < 198) {
        return "Fail"
      } else if (marks >= 198 && marks < 240) {
        return "D"
      } else if (marks >= 240 && marks < 300) {
        return "C2"
      }else if (marks >= 300 && marks < 360) {
        return "C1"
      }else if (marks >= 360 && marks < 420) {
        return "B2"
      }else if (marks >= 420 && marks < 480) {
        return "B1"
      }else if (marks >= 480 && marks < 540) {
        return "A2"
      }else if (marks >= 540 && marks < 600) {
        return "A1"
      } else {
        return "Undefined"
      }
    }
  
  
    const showOverallGrade = (marks)=> {
      if (marks < 396) {
        return "Fail"
      } else if (marks >= 396 && marks < 480) {
        return "D"
      } else if (marks >= 480 && marks < 600) {
        return "C2"
      }else if (marks >= 600 && marks < 720) {
        return "C1"
      }else if (marks >= 720 && marks < 840) {
        return "B2"
      }else if (marks >= 840 && marks < 960) {
        return "B1"
      }else if (marks >= 960 && marks < 1080) {
        return "A2"
      }else if (marks >= 1080 && marks < 1200) {
        return "A1"
      } else {
        return "Undefined"
      }
    }
  
  
    let totalObtainEnglishTerm1 = parseFloat(perTestExamEnglishTerm1)+parseFloat(noteBookEnglishTerm1)+parseFloat(subjectEnrichmentEnglishTerm1)+parseFloat(halfYearlyExamEnglishTerm1); 
    let totalObtainHindiTerm1 = parseFloat(perTestExamHindiTerm1)+parseFloat(noteBookHindiTerm1)+parseFloat(subjectEnrichmentHindiTerm1)+parseFloat(halfYearlyExamHindiTerm1);
    let totalObtainMathsTerm1 = parseFloat(perTestExamMathsTerm1)+parseFloat(noteBookMathsTerm1)+parseFloat(subjectEnrichmentMathsTerm1)+parseFloat(halfYearlyExamMathsTerm1);
    let totalObtainScienceTerm1 = parseFloat(perTestExamScienceTerm1)+parseFloat(noteBookScienceTerm1)+parseFloat(subjectEnrichmentScienceTerm1)+parseFloat(halfYearlyExamScienceTerm1);
    let totalObtainSanskritTerm1 = parseFloat(perTestExamSanskritTerm1)+parseFloat(noteBookSanskritTerm1)+parseFloat(subjectEnrichmentSanskritTerm1)+parseFloat(halfYearlyExamSanskritTerm1);
    let totalObtainSocialScienceTerm1 = parseFloat(perTestExamSocialScienceTerm1)+parseFloat(noteBookSocialScienceTerm1)+parseFloat(subjectEnrichmentSocialScienceTerm1)+parseFloat(halfYearlyExamSocialScienceTerm1);
  
    let totalObtainedMarksTerm1 = parseFloat(totalObtainEnglishTerm1) + parseFloat(totalObtainHindiTerm1) + parseFloat(totalObtainMathsTerm1) + parseFloat(totalObtainScienceTerm1) + parseFloat(totalObtainSanskritTerm1) + parseFloat(totalObtainSocialScienceTerm1);
    let percentageTerm1 = (totalObtainedMarksTerm1 / totalMarksTerm1) * 100 ;
  
    let totalObtainEnglishTerm2 = parseFloat(perTestExamEnglishTerm2)+parseFloat(noteBookEnglishTerm2)+parseFloat(subjectEnrichmentEnglishTerm2)+parseFloat(halfYearlyExamEnglishTerm2); 
    let totalObtainHindiTerm2 = parseFloat(perTestExamHindiTerm2)+parseFloat(noteBookHindiTerm2)+parseFloat(subjectEnrichmentHindiTerm2)+parseFloat(halfYearlyExamHindiTerm2);
    let totalObtainMathsTerm2 = parseFloat(perTestExamMathsTerm2)+parseFloat(noteBookMathsTerm2)+parseFloat(subjectEnrichmentMathsTerm2)+parseFloat(halfYearlyExamMathsTerm2);
    let totalObtainScienceTerm2 = parseFloat(perTestExamScienceTerm2)+parseFloat(noteBookScienceTerm2)+parseFloat(subjectEnrichmentScienceTerm2)+parseFloat(halfYearlyExamScienceTerm2);
    let totalObtainSanskritTerm2 = parseFloat(perTestExamSanskritTerm2)+parseFloat(noteBookSanskritTerm2)+parseFloat(subjectEnrichmentSanskritTerm2)+parseFloat(halfYearlyExamSanskritTerm2);
    let totalObtainSocialScienceTerm2 = parseFloat(perTestExamSocialScienceTerm2)+parseFloat(noteBookSocialScienceTerm2)+parseFloat(subjectEnrichmentSocialScienceTerm2)+parseFloat(halfYearlyExamSocialScienceTerm2);
  
    let totalObtainedMarksTerm2 = parseFloat(totalObtainEnglishTerm2) + parseFloat(totalObtainHindiTerm2) + parseFloat(totalObtainMathsTerm2) + parseFloat(totalObtainScienceTerm2) + parseFloat(totalObtainSanskritTerm2) + parseFloat(totalObtainSocialScienceTerm2);
    let percentageTerm2 = (totalObtainedMarksTerm2 / totalMarksTerm2) * 100 ;
  
    let overallObtainedMarks = totalObtainedMarksTerm1 + totalObtainedMarksTerm2 ;
    
    let overallPercentage = (overallObtainedMarks / ovarallMarks ) * 100 ;
  return (
    <div className="w-full p-5 text-gray-700">
    <div className="grid grid-cols-7 gap-4">
    <div className='justify-self-end items-center' >
     <img src="../assets/sail.png" alt="pic" className='h-24 w-24' />
    </div>
    <div className="mb-2 text-center w-full col-span-5">
    <div className='mb-1 '> 
            <span className="font-bold  text-3xl ">
                BOKARO ISPAT SENIOR SECONDARY SCHOOL 8B
            </span>
    </div>
    <div className='grid grid-cols-9 gap-4'>
    <div className='mb-1 col-span-5 ml-10'> 
    <span className="text-xl ">
                BOKARO STEEL CITY, JHARKHAND (INDIA)
             </span>
    </div>
    </div>  
    <div className="flex justify-center items-center mt-6 ">
          <div className="md:w-1/5 ">
            <label
              className="block font-bold md:text-left "
            >
              Academic Session
            </label>
          </div>
          <div className="md:w-1/5">
            <input
              type="text"  
              placeholder='2022-2023'         
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
              value={academicSession}
              onChange={(e) => {
                setAcademicSession(e.target.value);
              }}
            />
          </div>
        </div>
  <div className='mb-1'> 
  <span className="block font-bold md:text-center mb-1 md:mb-0 pr-4 text-2xl underline underline-offset-8 ">
    REPORT CARD FOR THE CLASS-<span>{studiedRoman}</span>/ { classSection.length>0? <span>{classSection}</span>:<></>}
    </span>
  </div>
  </div>
    <div className='justify-items-center items-center' >
     <img src="../assets/as_logo.png" alt="pic" className='h-24 w-24' />
    </div>
    </div>
        <div className="grid grid-cols-3  pl-5 pr-5 ">
            <div className="  text-black-500 text-lg font-bold text-center pt-10  ">
            <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Class
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select
              onChange={(e)=>setStudied(e.target.value)}
              className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            ><option value="null">Please Select Standard</option>
              {Class.map((item,index)=>
              (<option value={item.num} key={index}>{item.num}</option>)
              )
              }
              </select>
                  </div>
                </div>
              </div>
            
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6 ">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Student's Name
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                     type="text"
                     name="fName"
                     id="fName"
                     placeholder="Student's Name"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      value={studentName}
                      onChange={(e) => setStudentName(e.target.value)}
                    />
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                     Mother's Name
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                      type="text"
                      placeholder="Mother's Name"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      value={mothersName}
                      onChange={(e) => {
                      setMothersName(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>

            </div>
            <div className=" text-black-500 text-lg font-bold text-center pt-10  pl-10 ">
            <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                     Section
                    </label>
                  </div>
                  <div className="md:w-1/2">
                  <select 
                    value={classSection}
                   onChange={(e) => {
                  setClassSection(e.target.value);
                           }}
                          className="form-select  block w-full px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      aria-label="Default select example"
                    >
                      <option value="null"> select</option>
                      <option value="A">A</option>
                      <option value="B">B</option>
                    </select>
                  </div>
                </div>
              </div>
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Student ID
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                      type="text"
                      name="studentId"
                      id="studentId"
                      placeholder="Student ID"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      value={studentIdNumber}
                      onChange={(e) => setStudentIdNumber(e.target.value)}
                     />
                  </div>
                </div>
              </div>
             
             
              <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Father's Name
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                      type="text"
                      placeholder="Father's Name"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      value={fathersName}
                      onChange={(e) => {
                      setFathersName(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className=" text-black-500 text-lg font-bold text-center pt-10  pl-10 ">
            <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                      Roll No.
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                      type="text"
                      placeholder="Roll No."
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      value={classRollNumber}
                      onChange={(e) => {
                      setClassRollNumber(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            <div className="w-full max-w-sm">
                <div className="md:flex md:items-center mb-6">
                  <div className="md:w-1/2">
                    <label
                      className="block text-gray-500 font-bold md:text-left mb-1 md:mb-0 pr-4"
                      htmlFor="inline-full-name"
                    >
                     Date of Birth
                    </label>
                  </div>
                  <div className="md:w-1/2">
                    <input
                      type="date"
                      className=" w-full  px-3 py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      value={dateOfBirth}
                      onChange={(e) => {
                      setDateOfBirth(e.target.value);
                      }}
                    />
                   
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='flex gap-4 justify-items-start pl-10'>
            <button className=" bg-[#6c707b] text-white font-bold py-2 px-10 rounded-full text-2xl shadow-lg"
               onClick={() => {
                setSelectedTerm("Term I");
              }}
              style={{ color: selectedTerm === "Term I" ? "#fff " : "#fff" }}
            >Term I</button>
            <button className=" bg-[#6c707b] text-white font-bold py-2 px-10 rounded-full text-2xl shadow-lg"
               onClick={() => {
                setSelectedTerm("Term II");
              }}
              style={{ color: selectedTerm === "Term II" ? "#fff " : "#fff" }}
            >Term II</button>
          </div>


          {selectedTerm === "Term I" ? (  
          <div className="mt-5">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <div className="text-xl text-white uppercase py-3  font-semibold bg-[#6c707b] ">
              Term-I (100 Marks)
            </div>
            <table className="min-w-full border text-center">
            <thead className="border-b ">
                <tr className="bg-gray-100">
                  <th className="py-3">Subject Name</th>
                  <th className="py-3">Per Test (10)</th>
                  <th className="py-3">Note Book (05)</th>
                  <th className="py-3">Subject Enrichment (05)</th>
                  <th className="py-3">Half Yearly Exam (80)</th>
                  <th className="py-3">Marks Obtained (100)</th>
                  <th className="py-3">Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    English
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamEnglishTerm1}
                      onChange={(e) => {
                        setPerTestExamEnglishTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookEnglishTerm1}
                      onChange={(e) => {
                        setNoteBookEnglishTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentEnglishTerm1}
                      onChange={(e) => {
                        setSubjectEnrichmentEnglishTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamEnglishTerm1}
                      onChange={(e) => {
                        setHalfYearlyExamEnglishTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainEnglishTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r" >
                  {showGradeTerm1(totalObtainEnglishTerm1)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    Hindi
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamHindiTerm1}
                      onChange={(e) => {
                        setPerTestExamHindiTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookHindiTerm1}
                      onChange={(e) => {
                        setNoteBookHindiTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentHindiTerm1}
                      onChange={(e) => {
                        setSubjectEnrichmentHindiTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamHindiTerm1}
                      onChange={(e) => {
                        setHalfYearlyExamHindiTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainHindiTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm1(totalObtainHindiTerm1)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Sanskrit
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamSanskritTerm1}
                      onChange={(e) => {
                        setPerTestExamSanskritTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookSanskritTerm1}
                      onChange={(e) => {
                        setNoteBookSanskritTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentSanskritTerm1}
                      onChange={(e) => {
                        setSubjectEnrichmentSanskritTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamSanskritTerm1}
                      onChange={(e) => {
                        setHalfYearlyExamSanskritTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainSanskritTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm1(totalObtainSanskritTerm1)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    Maths
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamMathsTerm1}
                      onChange={(e) => {
                        setPerTestExamMathsTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookMathsTerm1}
                      onChange={(e) => {
                        setNoteBookMathsTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentMathsTerm1}
                      onChange={(e) => {
                        setSubjectEnrichmentMathsTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamMathsTerm1}
                      onChange={(e) => {
                        setHalfYearlyExamMathsTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainMathsTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm1(totalObtainMathsTerm1)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    Science
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamScienceTerm1}
                      onChange={(e) => {
                        setPerTestExamScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookScienceTerm1}
                      onChange={(e) => {
                        setNoteBookScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentScienceTerm1}
                      onChange={(e) => {
                        setSubjectEnrichmentScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamScienceTerm1}
                      onChange={(e) => {
                        setHalfYearlyExamScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainScienceTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm1(totalObtainScienceTerm1)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  S.Science
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamSocialScienceTerm1}
                      onChange={(e) => {
                        setPerTestExamSocialScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookSocialScienceTerm1}
                      onChange={(e) => {
                        setNoteBookSocialScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "1"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentSocialScienceTerm1}
                      onChange={(e) => {
                        setSubjectEnrichmentSocialScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      maxLength = "2"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamSocialScienceTerm1}
                      onChange={(e) => {
                        setHalfYearlyExamSocialScienceTerm1(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainSocialScienceTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm1(totalObtainSocialScienceTerm1)}
                  </td>
                
                </tr>

              </tbody>
            </table>
            <table className="min-w-full border text-center">
              <tbody>
                    <tr>
                    <td className="py-2 px-3 text-sm font-medium text-gray-900 "> 
                    Total Marks : {totalMarksTerm1}
                  </td>
                  <td className="py-2 px-1 text-sm font-medium text-gray-900 ">
                    Obtained Marks : {totalObtainedMarksTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                     PercentageTerm1 : {percentageTerm1}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                   Grade : {showTotalGradeTerm1(totalObtainedMarksTerm1)}
                  </td>
                    </tr>
              </tbody>
            </table>
          </div>
        <div className="mt-5">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <table className="table-auto min-w-full border text-center">
              <thead className="border-b">
                <tr className="bg-gray-100 ">
                  <th className="py-2 text-sm">Co-Scholastic Areas: Term-I [on a 3-point(A-C) grading Scale]</th>
                  <th className="py-2 text-sm" >Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    Work Education (or Pre-Vocational Education)
                  </td>       
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                  </td>                 
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  Art Education
                  </td>      
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                    </td>            
                </tr>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    Health & Physical Education
                  </td> 
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                    </td>                 
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt-5">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
          <table className="min-w-full border text-center">
              <thead className="border-b ">
                <tr className="bg-gray-100 ">
                <th className="py-2 text-sm">Discipline</th>
                  <th className="py-2 text-sm">Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                     DISCIPLINE : TERM-I [ON A 3-POINT (A-C) grading scale]
                  </td>
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                    </td>   
                </tr>
             
              </tbody>
            </table>
          </div>
        </div>
        <div className="mt-4 ">
        <button
          className="w-24 h-10 bg-blue-400  text-2xl text-white font-semibold"
          onClick={addresults}
        >
          Submit
        </button>
      </div>
        </div>
          ) : (
        <div className="mt-5">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <div className="text-xl text-white uppercase py-3  font-semibold bg-[#6c707b] ">
              Term-II (100 Marks)
            </div>
            <table className="min-w-full border text-center">
            <thead className="border-b ">
                <tr className="bg-gray-100">
                  <th className="py-3">Subject Name</th>
                  <th className="py-3">Per Test (10)</th>
                  <th className="py-3">Note Book (05)</th>
                  <th className="py-3">Subject Enrichment (05)</th>
                  <th className="py-3">Half Yearly Exam (80)</th>
                  <th className="py-3">Marks Obtained (100)</th>
                  <th className="py-3">Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    English
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamEnglishTerm2}
                      onChange={(e) => {
                        setPerTestExamEnglishTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookEnglishTerm2}
                      onChange={(e) => {
                        setNoteBookEnglishTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentEnglishTerm2}
                      onChange={(e) => {
                        setSubjectEnrichmentEnglishTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamEnglishTerm2}
                      onChange={(e) => {
                        setHalfYearlyExamEnglishTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainEnglishTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm2(totalObtainEnglishTerm2)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    Hindi
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamHindiTerm2}
                      onChange={(e) => {
                        setPerTestExamHindiTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookHindiTerm2}
                      onChange={(e) => {
                        setNoteBookHindiTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentHindiTerm2}
                      onChange={(e) => {
                        setSubjectEnrichmentHindiTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamHindiTerm2}
                      onChange={(e) => {
                        setHalfYearlyExamHindiTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainHindiTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm2(totalObtainHindiTerm2)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  Sanskrit
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamSanskritTerm2}
                      onChange={(e) => {
                        setPerTestExamSanskritTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookSanskritTerm2}
                      onChange={(e) => {
                        setNoteBookSanskritTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentSanskritTerm2}
                      onChange={(e) => {
                        setSubjectEnrichmentSanskritTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamSanskritTerm2}
                      onChange={(e) => {
                        setHalfYearlyExamSanskritTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainSanskritTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm2(totalObtainSanskritTerm2)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    Maths
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamMathsTerm2}
                      onChange={(e) => {
                        setPerTestExamMathsTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookMathsTerm2}
                      onChange={(e) => {
                        setNoteBookMathsTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentMathsTerm2}
                      onChange={(e) => {
                        setSubjectEnrichmentMathsTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamMathsTerm2}
                      onChange={(e) => {
                        setHalfYearlyExamMathsTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainMathsTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm2(totalObtainMathsTerm2)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                    Science
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamScienceTerm2}
                      onChange={(e) => {
                        setPerTestExamScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookScienceTerm2}
                      onChange={(e) => {
                        setNoteBookScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentScienceTerm2}
                      onChange={(e) => {
                        setSubjectEnrichmentScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamScienceTerm2}
                      onChange={(e) => {
                        setHalfYearlyExamScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainScienceTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm2(totalObtainScienceTerm2)}
                  </td>
                
                </tr>
                <tr className="border-b">
                  <td className="py-2 px-10 text-sm font-medium text-gray-900 border-r">
                  S.Science
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='per '
                      value={perTestExamSocialScienceTerm2}
                      onChange={(e) => {
                        setPerTestExamSocialScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='Note'
                      value={noteBookSocialScienceTerm2}
                      onChange={(e) => {
                        setNoteBookSocialScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='enrichment'
                      value={subjectEnrichmentSocialScienceTerm2}
                      onChange={(e) => {
                        setSubjectEnrichmentSocialScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  <input
                      type="text"
                      className=" w-24 px-1  text-base font-normal text-gray-700 bg-white bg-clip-padding  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
                      placeholder='h.y'
                      value={halfYearlyExamSocialScienceTerm2}
                      onChange={(e) => {
                        setHalfYearlyExamSocialScienceTerm2(e.target.value);
                      }}
                    />
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                    {totalObtainSocialScienceTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 border-r">
                  {showGradeTerm2(totalObtainSocialScienceTerm2)}
                  </td>
                
                </tr>

              </tbody>
            </table>
            <table className="min-w-full border text-center">
              <tbody>
                    <tr>
                    <td className="py-2 px-3 text-sm font-medium text-gray-900 "> 
                    Total Marks : {totalMarksTerm2}
                  </td>
                  <td className="py-2 px-1 text-sm font-medium text-gray-900 ">
                    Obtained Marks : {totalObtainedMarksTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                     PercentageTerm2 : {percentageTerm2}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                   Grade : {showTotalGradeTerm2(totalObtainedMarksTerm2)}
                  </td>
                    </tr>
              </tbody>
            </table>
          </div>
          <div className='grid grid-cols-2 gap-2'>
          <div className="mt-5">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
            <table className="table-auto min-w-full border text-center">
              <thead className="border-b ">
                <tr className="bg-gray-100 ">
                  <th className="py-2 text-sm">Co-Scholastic Areas: Term-II [on a 3-point(A-C) grading Scale]</th>
                  <th className="py-2 text-sm">Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    Work Education (or Pre-Vocational Education)
                  </td>     <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                    </td>                
                </tr>
                <tr className="border-b bg-gray-100">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  Art Education
                  </td>        <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                    </td>             
                </tr>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    Health & Physical Education
                  </td>      <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                    </td>               
                </tr>
              </tbody>
            </table>
          </div>
        <div className="mt-5">
          <div className="overflow-x-auto shadow-md sm:rounded-lg">
          <table className="min-w-full border text-center">
              <thead className="border-b ">
                <tr className="bg-gray-100 ">
                <th className="py-2 text-sm">Discipline</th>
                  <th className="py-2 text-sm">Grade</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b">
                  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                     DISCIPLINE : TERM-II [ON A 3-POINT (A-C) grading scale]
                  </td>  <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                    
                    </td>   
                </tr>
             
              </tbody>
            </table>
          </div>
        </div>
        </div>
        <div className='mt-10'>
        <div className=' text-left'>
        <div className='mb-1 ml-10'> 
             <span className="block font-bold text-md ">
              Class Teacher's Remarks :
               </span>
          </div>
        <div className="flex ml-10 mb-2 ">
          <div className="md:w-1/2 ">
            <label
              className="block font-bold md:text-left "
            >
             Promoted to Class : 
            </label>
          </div>
          <div className="md:w-2/5">
            <input
              type="text"           
              className=" w-full  px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        <div className="flex ml-10 mb-2 ">
          <div className="md:w-1/2 ">
            <label
              className="block font-bold md:text-left "
            >
             Place : 
            </label>
          </div>
          <div className="md:w-2/5">
            <input
              type="text"           
              className=" w-full  px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        <div className="flex ml-10 mb-2  ">
          <div className="md:w-1/2 ">
            <label
              className="block font-bold md:text-left "
            >
             Date : 
            </label>
          </div>
          <div className="md:w-2/5">
            <input
              type="date"           
              className=" w-full  px-3 py-1 text-base font-normal text-gray-700 bg-white bg-clip-padding border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none"
            />
          </div>
        </div>
        </div>
        </div>
          </div>
  {/* overAll Marks */}
  <table className="min-w-full border text-center mt-10">
        <thead className="border-b justify-center ">
                <tr className="bg-gray-100">
                 <th></th>
                <th className="py-3">OverAll Marks </th>
                <th></th>
                <th></th>
                </tr>
              </thead>
              <tbody>
                    <tr>
                    <td className="py-2 px-3 text-sm font-medium text-gray-900 "> 
                    Overall Total Marks : {ovarallMarks}
                  </td>
                  <td className="py-2 px-1 text-sm font-medium text-gray-900 ">
                   Overall Obtained Marks : {overallObtainedMarks}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                     Overall Percentage : {overallPercentage}
                  </td>
                  <td className="py-2 px-2 text-sm font-medium text-gray-900 ">
                   Grade : {showOverallGrade(overallObtainedMarks)}
                  </td>
                    </tr>
              </tbody>
            </table>
            <div className="mt-4 ">
        <button
          className="w-24 h-10 bg-blue-400  text-2xl text-white font-semibold"
          
        >
          Submit
        </button>
      </div>
        </div>
          )}
    </div>
  )
}

export default ResultStudentTerm1